import React from 'react';
import { testimonials } from '../config/testimonials';

// Renders nothing while the testimonials list is empty - never show placeholder/fake quotes.
export const TestimonialsSection = () => {
  if (!testimonials || testimonials.length === 0) return null;

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-20" data-testid="landing-testimonials">
      <h2 className="text-3xl sm:text-4xl font-bold text-[#111827] mb-10 text-center" style={{ fontFamily: 'Outfit, sans-serif' }}>
        What our customers are saying
      </h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {testimonials.map((t, i) => (
          <div
            key={i}
            className="bg-white rounded-2xl border border-[#DBEAFE] p-6"
            data-testid={`testimonial-card-${i}`}
          >
            <p className="text-[#374151] text-sm sm:text-base leading-relaxed mb-4">&ldquo;{t.quote}&rdquo;</p>
            <div className="text-sm font-semibold text-[#111827]">{t.name}</div>
            <div className="text-xs text-[#6B7280]">{t.business}</div>
          </div>
        ))}
      </div>
    </section>
  );
};
